import * as routing from "@baseline/web/routing/legacy";
import { Handler } from "./handler";
import { RoutePathArgumentTypes, RoutePathArgumentsFor } from "./route-path";


export * from "@baseline/web/routing/legacy/route";


export interface Route<T extends RoutePathArgumentTypes = RoutePathArgumentTypes> extends routing.Route
{
    handlers: Handler<RoutePathArgumentsFor<T>>[];
}

export const Route = routing.Route;
